import Activity from './activity'
export type { ActivityProps } from './activity'
export default Activity
